<template>
  <div class="moduleContainer">
    <div class="header">
      <div class="title">
        <i class="el-icon-s-check"></i>
        待审核
      </div>
      <el-checkbox
        v-model="SearchData.is_deal"
        true-label=" "
        false-label="false"
        @change="GetTableList(true)"
        >显示已处理审核</el-checkbox
      >
    </div>
    <div class="auth">
      <el-table
        :data="TableList"
        :stripe="true"
        @selection-change="HandleSelectionChange"
        @sort-change="HandleSortChange"
        style="box-shadow: none"
      >
        <TableOperation
          :operationList="[
            {
              is_show: (row) => true,
              label: '处理',
              command: 'viewMatter',
            },
            {
              is_show: (row) => row.module == 'business_action_purchase'&&!row.is_deal,
              label: '忽略',
              command: 'ingoreMatter',
            },
          ]"
          @handleOperation="HandleOperation"
        />
        <el-table-column :label="l('类型')" width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ $utils.listFilter(moduleList, scope.row.module) }}
          </template>
        </el-table-column>
        <el-table-column prop="title" :label="l('信息')" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="来源" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.tenant">
                {{ scope.row.tenant.name }}
            </span>
            <span v-else-if="!scope.row.tenant && scope.row.user" style="color:#ccc">
              {{ scope.row.user.pre_company_name }}
            </span>
            {{ scope.row.user && scope.row.user.mobile }}
          </template>
        </el-table-column>

        <el-table-column
          prop="created_time"
          label="提审时间"
          show-overflow-tooltip
        ></el-table-column>

        <el-table-column label="审核结果" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.is_deal">
              <span v-if="scope.row.result=='忽略'" class="color-danger">忽略</span>
              <span v-else class="color-success">{{ scope.row.result }}</span>
              
            </span>
            <span v-else style="color: #ccc">待审核</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="TotalCount"
        style="margin-top: 30px; justify-content: center"
        background
        @size-change="HandleSizeChange"
        @current-change="HandleCurrentChange"
        :current-page="CurrentPage"
        :page-sizes="PageSizeList"
        :page-size="PageSize"
        layout="total, prev, pager, next, jumper"
        :total="TotalCount"
      ></el-pagination>
      <TenantAuth ref="TenantAuth" @submitDialog="GetTableList" />
      <CreateOrEditAdminPurchase
        ref="CreateOrEditAdminPurchase"
        @submitDialog="GetTableList"
      />
      <CreateOrEditAdminQuotation
        ref="CreateOrEditAdminQuotation"
        @submitDialog="GetTableList"
      />

      <CreateOrEditAdminForum
        ref="CreateOrEditAdminForum"
        @submitDialog="GetTableList"
      />

      <CreateOrEditAdminForum
        ref="CreateOrEditAdminForumDiscuss"
        mode="discuss"
        @submitDialog="GetTableList"
      />

      <AuthBusinessDialog
        ref="AuthBusinessDialog"
        @submitDialog="GetTableList"
      />
    </div>
  </div>
</template>

<script>
import tableMixin from "@/assets/js/tableMixin";
import TenantAuth from "./TenantAuth.vue";
import CreateOrEditAdminPurchase from "@/views/admin_purchase/operation/CreateOrEditAdminPurchase.vue";
import CreateOrEditAdminQuotation from "@/views/admin_quotation/operation/CreateOrEditAdminQuotation.vue";
import CreateOrEditAdminForum from "@/views/admin_forum/operation/CreateOrEditAdminForum.vue";
import AuthBusinessDialog from "@/views/admin_dashboard/operation/AuthBusinessDialog.vue";
export default {
  name: "Auth",
  mixins: [tableMixin],
  components: {
    TenantAuth,
    CreateOrEditAdminPurchase,
    CreateOrEditAdminQuotation,
    CreateOrEditAdminForum,
    AuthBusinessDialog
  },
  data() {
    return {
      SearchData: {
        is_deal: "false",
      },
      ScrollAfterChange: false,
      moduleList: [
        {
          id: "tenant_authentication",
          name: "企业认证",
        },
        {
          id: "purchase_material",
          name: "原料求购",
        },
        {
          id: "purchase_piece",
          name: "零切交易",
        },
        {
          id: "purchase_forging",
          name: "锻件定制",
        },
        {
          id: "quotation",
          name: "现货卖场",
        },
        {
          id: "forum",
          name: "论坛帖子",
        },
        {
          id: "forum_discuss",
          name: "论坛评论",
        },
        {
          id: "business_action_purchase",
          name: "报价"
        }
      ],
    };
  },
  methods: {
    viewMatter(row) {
      if (row.module == "tenant_authentication") {
        this.$refs.TenantAuth.Type = "View";
        this.$refs.TenantAuth.Show({ id: row.record_sign });
      } else if (
        row.module == "purchase_material" ||
        row.module == "purchase_piece" ||
        row.module == "purchase_forging"
      ) {
        this.$refs.CreateOrEditAdminPurchase.Type = "View";
        this.$refs.CreateOrEditAdminPurchase.Show({ code: row.record_sign });
      } else if (row.module == "quotation") {
        this.$refs.CreateOrEditAdminQuotation.Type = "View";
        this.$refs.CreateOrEditAdminQuotation.Show({ code: row.record_sign });
      } else if (row.module == "forum") {
        this.$refs.CreateOrEditAdminForum.Type = "View";
        this.$refs.CreateOrEditAdminForum.Show({ id: row.record_sign });
      } else if (row.module == "forum_discuss") {
        this.$refs.CreateOrEditAdminForumDiscuss.Type = "View";
        this.$refs.CreateOrEditAdminForumDiscuss.Show({ id: row.record_sign });
      }else if(row.module == "business_action_purchase"){
        this.$refs.AuthBusinessDialog.Type = "View";
        this.$refs.AuthBusinessDialog.Show({code: row.record_sign, module: "purchase"});
      }
    },
    ingoreMatter(row) {
      this.$confirm("是否忽略该审核项?", "", {
        type: "warning",
      }).then(() => {
        console.log(row.id)
        this.axios
        .put(`/api/admin_matter/${row.id}/ignore/`)
        .then((data) => {});
      });
    },
    GetTableList(resetPage) {
      if (resetPage == true) this.CurrentPage = 1;
      this.axios
        .get("/api/admin_matter/", {
          params: {
            ...this.SearchData,
            ordering: this.Sorting,
            size: this.PageSize,
            page: this.CurrentPage,
          },
        })
        .then((data) => {
          this.TotalCount = data.count;
          this.TableList = data.results;
        });
    },
  },
};
</script>


<style scoped lang="scss">
.moduleContainer {
  width: 100%;
  background: #fff;
  margin-top: 15px;
  padding-bottom: 20px;
  .header {
    padding: 18px 0;
    margin: 0 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: bold;
    border-bottom: 1px solid $borderPlainColor;
    i {
      margin-right: 4px;
      color: $warningColor;
      font-size: 18px;
    }
  }
}
.auth {
  padding: 0 20px;
}
</style>

